import React, { useState, useEffect } from "react";
import { useAuth } from "../../Common/Configurations/AuthContext";
import Header from "../../Common/Layout/Header";
import { Link, useLocation, useNavigate, useParams } from "react-router-dom";
import moment from "moment";
import config from "../../Common/Configurations/APIConfig";
import apiService from "../../Common/Configurations/APIService";
import FlightTabs from "../AllTabs/FlightTabs";
import Login from "../../Authentication/Login";
import EditFlightBookingModal from "./EditFlightBookingModal"; // We'll create this component

const FlightBookingDetails = () => {
  const params = useParams();
  const navigate = useNavigate();
  const [pageLoading, setPageLoading] = useState(false);
  const { user, loading } = useAuth();
  const [bookingDetails, setBookingDetails] = useState({});
  const [travellers, setTravellers] = useState([]);
  const [itinerary, setItinerary] = useState([]);
  const [showEditModal, setShowEditModal] = useState(false);

  function getTimeFromMins(mins) {
    var h = (mins / 60) | 0,
      m = mins % 60 | 0;
    var durationformat = h + "h " + m + "m";
    return durationformat;
  }

  const GetData = () => {
    setPageLoading(true);
    apiService
      .getAll(config.GETFLIGHTBOOKINGDETAILS + "/" + params.flightBookingId)
      .then((res) => {
        console.log(res);
        setBookingDetails(res);
        setItinerary(res.dcFlightLegs);
        setTravellers(res.travellerInfos);
        setPageLoading(false);
      })
      .catch((err) => console.error("Error fetching company data", err));
  };

  const handleEditSuccess = () => {
    setShowEditModal(false);
    GetData(); // Refresh the data after successful update
  };

  useEffect(() => {
    GetData();
  }, [user, loading]);

  if (loading) return <p>Loading...</p>;
  if (!user) {
    navigate("/");
  }

  return (
    <div id="layout-wrapper">
      <Header User={user} />
      <div className="main-content">
        <div className="page-content">
          <div className="container-fluid invoice-container">
            <div className="col-xl-12">
              <div className="card">
                <div className="p-2">
                  <FlightTabs pageName="FLIGHTBOOKING" />
                </div>
                <div className="card-body">
                  {pageLoading === true ? (
                    <div className="row align-items-center justify-content-center">
                      <div className="col-lg-12">
                        <img
                          src="/assets/images/loader.webp"
                          width={"64px"}
                          height={"64px"}
                        ></img>
                        Loading, Please wait...
                      </div>
                    </div>
                  ) : (
                    <div className="row align-items-center justify-content-center">
                      <div className="col-lg-12">
                        <div className="bg-white shadow-md rounded p-3 p-sm-4 confirm-details">
                          <div className="row">
                            <div className="col-8">
                              <h4 className="text-6 mb-3 mb-sm-4">
                                Flight Booking Details
                              </h4>
                            </div>
                            <div className="col-4">
                              <div className="btn-group btn-group-sm float-right d-print-none">
                                <Link
                                  to={
                                    "/flight/voucher/" + params.flightBookingId
                                  }
                                  className="btn btn-primary border text-white shadow-none me-2"
                                >
                                  <i className="ri-eye-line"></i> View Voucher
                                </Link>
                                <Link
                                  to={
                                    "/flight/invoice/" + params.flightBookingId
                                  }
                                  className="btn btn-secondary border text-white shadow-none me-2"
                                >
                                  <i className="ri-eye-line"></i> View Invoice
                                </Link>
                                {/* Edit Flight Booking Button */}
                                <button
                                  onClick={() => setShowEditModal(true)}
                                  className="btn btn-info border text-white shadow-none me-2"
                                >
                                  <i className="ri-edit-line"></i> Edit Flight
                                  Booking
                                </button>
                              </div>
                            </div>
                          </div>
                          <hr className="mx-n3 mx-sm-n4 mb-4" />
                          {itinerary.length > 0 &&
                            itinerary.map(
                              (it) =>
                                it.dcDisplayLegs?.length > 0 &&
                                it.dcDisplayLegs.map((leg, index) => (
                                  <div className="card" key={index}>
                                    <div className="card-header">
                                      <div className="row align-items-center trip-title">
                                        <div className="col-5 col-sm-auto text-center text-sm-start">
                                          <h5 className="m-0 trip-place">
                                            {leg.startSegment.city},{" "}
                                            {leg.startSegment.airportCode}
                                          </h5>
                                        </div>
                                        <div className="col-2 col-sm-auto text-8 text-black-50 text-center trip-arrow">
                                          ➝
                                        </div>
                                        <div className="col-5 col-sm-auto text-center text-sm-start">
                                          <h5 className="m-0 trip-place">
                                            {leg.endSegment.city},{" "}
                                            {leg.endSegment.airportCode}
                                          </h5>
                                        </div>
                                        <div className="col-12 mt-1 d-block d-md-none" />
                                        <div className="col-6 col-sm col-md-auto text-3 date">
                                          {moment(
                                            leg.startSegment.departureDateTime
                                          ).format("DD MMM YY")}
                                        </div>
                                        <div className="col col-md-auto text-center ms-auto order-sm-0">
                                          {it.flightLeg?.refundable ===
                                          "Refundable" ? (
                                            <span className="badge bg-success fw-normal text-1">
                                              {it.flightLeg?.refundable}
                                            </span>
                                          ) : (
                                            <span className="badge bg-danger fw-normal text-1">
                                              {it.flightLeg?.refundable}
                                            </span>
                                          )}
                                        </div>
                                        <div className="col col-md-auto text-center ml-auto order-sm-0">
                                          {bookingDetails.bookingStatus ===
                                          "CONFIRMED" ? (
                                            <span className="badge bg-success py-1 px-2 font-weight-normal text-2">
                                              Booking Status :{" "}
                                              {bookingDetails.bookingStatus}{" "}
                                              <i className="fas fa-check-circle"></i>
                                            </span>
                                          ) : bookingDetails.bookingStatus ===
                                            "HOLD" ? (
                                            <span className="badge bg-warning py-1 px-2 font-weight-normal text-2">
                                              Booking Status :{" "}
                                              {bookingDetails.bookingStatus}{" "}
                                              <i className="fas fa-check-circle"></i>
                                            </span>
                                          ) : (
                                            <span className="badge bg-danger py-1 px-2 font-weight-normal text-2">
                                              Booking Status :{" "}
                                              {bookingDetails.bookingStatus}{" "}
                                              <i className="fas fa-check-circle"></i>
                                            </span>
                                          )}
                                        </div>
                                      </div>
                                    </div>
                                    <div className="card-body">
                                      <p className="mt-3 line-height-4 text-1">
                                        PNR: {bookingDetails.pnr}
                                        <br />
                                        Booking No: {bookingDetails.bookingNo}
                                        <br />
                                        Supplier Confirmation:{" "}
                                        {bookingDetails.supplierBookingId}
                                        <br />
                                        Class of Service:{" "}
                                        {bookingDetails.cabinClass}
                                      </p>
                                      <div className="flight-details">
                                        <div className="tab-content my-3">
                                          {it.dcSegments.length > 0 &&
                                            it.dcSegments.map((seg) => (
                                              <>
                                                <div className="row flex-row pt-4 px-md-4">
                                                  <div className="col-12 col-sm-3 text-center d-lg-flex company-info">
                                                    {" "}
                                                    <span className="align-middle">
                                                      <img
                                                        className="img-fluid"
                                                        alt
                                                        src={
                                                          "/assets/images/airlinelogos/" +
                                                          seg.tFAirlineData
                                                            ?.airlineCode +
                                                          ".png"
                                                        }
                                                      />{" "}
                                                    </span>{" "}
                                                    <span className="align-middle ms-lg-2">
                                                      {" "}
                                                      <span className="d-block text-1 text-dark">
                                                        {
                                                          seg.tFAirlineData
                                                            ?.airline
                                                        }
                                                      </span>{" "}
                                                      <small className="text-muted d-block">
                                                        {seg.tFAirlineData
                                                          ?.equimentType +
                                                          "-" +
                                                          seg.tFAirlineData
                                                            ?.flightNumber}
                                                      </small>{" "}
                                                    </span>{" "}
                                                  </div>
                                                  <div className="col-12 col-sm-3 text-center time-info mt-3 mt-sm-0">
                                                    {" "}
                                                    <span className="text-5 text-dark">
                                                      {moment(
                                                        seg.tFDepartureData
                                                          .departureDateTime
                                                      ).format(
                                                        "DD MMM YY HH:mm"
                                                      )}
                                                    </span>{" "}
                                                    <small className="text-muted d-block">
                                                      {
                                                        seg.tFDepartureData
                                                          .airportName
                                                      }
                                                      ,{" "}
                                                      {seg.tFDepartureData.city}
                                                      ,{" "}
                                                      {
                                                        seg.tFDepartureData
                                                          .terminal
                                                      }
                                                    </small>{" "}
                                                  </div>
                                                  <div className="col-12 col-sm-3 text-center time-info mt-3 mt-sm-0">
                                                    {" "}
                                                    <span className="text-3 text-dark">
                                                      {getTimeFromMins(
                                                        seg.tFAirlineData
                                                          ?.duration
                                                      )}
                                                    </span>{" "}
                                                    <small className="text-muted d-block">
                                                      Duration
                                                    </small>{" "}
                                                  </div>
                                                  <div className="col-12 col-sm-3 text-center time-info mt-3 mt-sm-0">
                                                    {" "}
                                                    <span className="text-5 text-dark">
                                                      {moment(
                                                        seg.tFArrivalData
                                                          .arrivalDateTime
                                                      ).format(
                                                        "DD MMM YY HH:mm"
                                                      )}
                                                    </span>{" "}
                                                    <small className="text-muted d-block">
                                                      {
                                                        seg.tFArrivalData
                                                          .airportName
                                                      }
                                                      , {seg.tFArrivalData.city}
                                                      ,
                                                      {
                                                        seg.tFArrivalData
                                                          .terminal
                                                      }
                                                    </small>{" "}
                                                  </div>
                                                </div>
                                                {seg.tFAirlineData
                                                  .connectingTime !== 0 ? (
                                                  <div className="row flex-row pt-4 px-md-4">
                                                    <div className="col-12 col-sm-3 text-center d-lg-flex company-info">
                                                      <span className="badge bg-success">
                                                        CONNECTING TIME :{" "}
                                                        {getTimeFromMins(
                                                          seg.tFAirlineData
                                                            .connectingTime
                                                        )}
                                                      </span>
                                                    </div>
                                                  </div>
                                                ) : (
                                                  ""
                                                )}
                                              </>
                                            ))}
                                        </div>
                                      </div>
                                      {bookingDetails.dcPriceDetails?.length >
                                      0 ? (
                                        <p>
                                          Adult - Check-in:{" "}
                                          {
                                            bookingDetails.dcPriceDetails[0]
                                              .dcAdults.checkinBag
                                          }
                                          , Cabin:{" "}
                                          {
                                            bookingDetails.dcPriceDetails[0]
                                              .dcAdults.cabinBag
                                          }
                                        </p>
                                      ) : (
                                        ""
                                      )}
                                    </div>
                                  </div>
                                ))
                            )}
                        </div>
                        <div className="card">
                          <div className="card-header">
                            <h6 className="fw-semibold mb-0">
                              Traveler Details
                            </h6>
                          </div>
                          <div className="card-body">
                            <div className="table-responsive-md">
                              <table className="table table-hover table-bordered">
                                <thead>
                                  <tr>
                                    <th>SNo.</th>
                                    <th>Name</th>
                                    <th>Gender</th>
                                    <th>Type</th>
                                  </tr>
                                </thead>
                                <tbody>
                                  {travellers.length > 0 &&
                                    travellers.map((t, index) => (
                                      <tr key={index}>
                                        <td>{index + 1}</td>
                                        <td>
                                          {t.title}.{t.firstName} {t.lastName}
                                        </td>
                                        <td>{t.gender}</td>
                                        <td>{t.travelerType}</td>
                                      </tr>
                                    ))}
                                </tbody>
                              </table>

                              {/* Price Summary Section - Same as in FlightInvoice */}
                              <div
                                style={{
                                  width: "100%",
                                  display: "flex",
                                  justifyContent: "flex-end",
                                }}
                              >
                                <table
                                  className="table"
                                  style={{ width: "auto" }}
                                >
                                  <tbody>
                                    <tr>
                                      <td className="text-right">
                                        <ul className="list-unstyled">
                                          <li className="mb-2">
                                            <b>Net Price :</b>
                                            <span className="float-end text-3 fw-500 text-dark">
                                              {Math.round(
                                                bookingDetails.totalFare || 0
                                              )}{" "}
                                              INR
                                            </span>
                                          </li>
                                          <li className="mb-2">
                                            <b>Service Fee (Markup):</b>
                                            <span className="float-end text-3 fw-500 text-dark">
                                              {Math.round(
                                                parseInt(
                                                  bookingDetails.convenienceFee
                                                ) || 0
                                              )}{" "}
                                              INR
                                            </span>
                                          </li>
                                          <li className="mb-2">
                                            <b>
                                              GST ({bookingDetails.gst || 0}%) :
                                            </b>
                                            <span className="float-end text-3 fw-500 text-dark">
                                              {Math.round(
                                                parseInt(
                                                  bookingDetails.gstAmount
                                                ) || 0
                                              )}{" "}
                                              INR
                                            </span>
                                          </li>
                                          <li className="mb-2">
                                            <b>Payment Gateway Fee :</b>
                                            <span className="float-end text-3 fw-500 text-dark">
                                              {Math.round(
                                                parseInt(
                                                  bookingDetails.paymentGatewayAmount
                                                ) || 0
                                              )}{" "}
                                              INR
                                            </span>
                                          </li>
                                          {bookingDetails.discount !== 0 && (
                                            <li
                                              className="mb-2"
                                              style={{ color: "green" }}
                                            >
                                              <b>Discount :</b>
                                              <span className="float-end text-3 fw-500 text-green">
                                                (-{bookingDetails.discount || 0}{" "}
                                                INR)
                                              </span>
                                            </li>
                                          )}
                                          <li className="mb-2">
                                            <b>Total Price :</b>
                                            <span className="float-end text-3 fw-500 text-dark">
                                              {Math.round(
                                                bookingDetails.totalPrice || 0
                                              )}{" "}
                                              INR
                                            </span>
                                          </li>
                                        </ul>
                                      </td>
                                    </tr>
                                  </tbody>
                                </table>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Edit Flight Booking Modal */}
      {showEditModal && (
        <EditFlightBookingModal
          bookingDetails={bookingDetails}
          onClose={() => setShowEditModal(false)}
          onSuccess={handleEditSuccess}
        />
      )}
    </div>
  );
};

export default FlightBookingDetails;
